import { Box, Text } from "@chakra-ui/react";

const BigBasketLoginHeading = () => {
  return (
    <Box>
      <Text
        textAlign="center"
        color="#1877f2"
        fontSize="40px"
        fontWeight="600"
        fontFamily="Poppins"
      >
        Big Basket
      </Text>
    </Box>
  );
};

export default BigBasketLoginHeading;
